import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";
import paymentqr from "../images/payment.jpeg";

function BankDetails() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
          
            <div className="album py-1">
                <div className="container mt-2">
                    <p> CHUAPUKUR ISLAMIC CHARITABLE TRUST </p>
                </div>
            </div>
            <div className='charitabletrust'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Bank Details <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
           <div className="album py-0">
                <div className="container">
                    <div className="row">





                        <div className="col-md-6 mt-1">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad89'>BANK DETAILS <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-bank" viewBox="0 0 16 16">
  <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z"/>
</svg> </h4>

                                    <div className="card-body ">

                                        <div className='welcometext'>
                                            <br />
                                            
<h6 style={{color:"#107b0c"}}><b>BANK DETAILS: A/C No: 50200115596417 
    <br/>IFSC: HDFC0008658; HDFC Bank, Lalgola Branch: MSD: WB</b></h6>
                                        <img src={paymentqr}  height="380px" width="280px" alt="paymentqr"/>

                                            <br />
                                            <br />
                                           

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
</div>
</div>
</div>

            <br />
        </div>
    )
}

export default BankDetails